import React, { useState } from 'react';
import Login from '../components/Login';
import './MaintenancePage.css';

function MaintenancePage({ onLoginSuccess }) {
    const [showLogin, setShowLogin] = useState(false);

    return (
        <div className="maintenance-page">
            <div className="maintenance-container">
                <div className="maintenance-icon">
                    <span role="img" aria-label="maintenance">🔧</span>
                </div>
                <h1 className="maintenance-title">Under Maintenance</h1>
                <p className="maintenance-message">
                    We're currently performing scheduled maintenance to improve your experience.
                </p>
                <p className="maintenance-submessage">
                    We'll be back shortly. Thank you for your patience!
                </p>
                <div className="maintenance-animation">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                </div>
                {showLogin ? (
                    <div className="maintenance-login">
                        <Login onLoginSuccess={onLoginSuccess} />
                    </div>
                ) : (
                    <button
                        type="button"
                        className="maintenance-staff-login"
                        onClick={() => setShowLogin(true)}
                    >
                        Staff / moderator login
                    </button>
                )}
            </div>
        </div>
    );
}

export default MaintenancePage;
